import { render, staticRenderFns } from "./examSetting.vue?vue&type=template&id=220c9fa4&scoped=true&"
import script from "./examSetting.vue?vue&type=script&lang=js&"
export * from "./examSetting.vue?vue&type=script&lang=js&"
import style0 from "./examSetting.vue?vue&type=style&index=0&id=220c9fa4&scoped=true&lang=scss&"
import style1 from "./examSetting.vue?vue&type=style&index=1&id=220c9fa4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220c9fa4",
  null
  
)

export default component.exports